"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScoreContainer = void 0;
const lodash_1 = __importDefault(require("lodash"));
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const styled_components_1 = __importStar(require("styled-components"));
const Colors_1 = require("../../../../../Colors");
const common_1 = require("../../../../../common");
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const EvaluationTable_1 = require("./EvaluationTable");
const ScoreStyled = styled_components_1.default.div `
	&.score-container {
		display: flex;
		flex-direction: column;
		gap: 16px;
		align-items: flex-start;
		justify-content: flex-start;
		position: relative;
		width: 100%;
		height: 100%;

		.task-label {
			display: flex;
			flex-direction: row;
			gap: 8px;
			width: 100%;
		}

		&.empty {
			flex: 1;
			align-items: center;
			justify-content: center;
		}
	}

	.class-container {
		width: 100%;
		height: fit-content;
	}

	${props => (props.$isTablet ? tabletStyles : props.$isMobile ? mobileStyles : desktopStyles)}
`;
const mobileStyles = (0, styled_components_1.css) `
	.class-container {
		padding: 12px 0;
	}

	.table-title-wrap {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: center;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
	}

	.notice-txt {
		color: var(--color-accent, #e7424c);
		font-family: 'Noto Sans KR', sans-serif;
		font-size: 10px;
		line-height: 150%;
		letter-spacing: -0.02em;
		font-weight: 400;
		position: relative;
		// width: 184px;
		text-overflow: ellipsis;
		overflow: hidden;
	}
`;
const tabletStyles = (0, styled_components_1.css) `
	&.score-container {
		&.empty {
			font-family: 'Noto Sans KR', sans-serif;
			font-size: 14px;
			line-height: 150%;
			letter-spacing: -0.02em;
			font-weight: 400;
			position: relative;
		}
	}

	.class-container {
		padding: 0px 0px 6px 0px;
		gap: 0px;
	}

	.table-title-wrap {
		padding: 0px 0px 6px 0px;
		display: flex;
		flex-direction: row;
		align-items: flex-end;
		justify-content: space-between;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;

		.task-label {
			width: min-content;
			display: flex;
			gap: 8px;
		}
	}

	.notice-txt {
		color: var(--color-accent, #e7424c);
		text-align: right;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: 10px;
		line-height: 150%;
		letter-spacing: -0.02em;
		font-weight: 400;
		position: relative;
		// width: 184px;
		text-overflow: ellipsis;
		overflow: hidden;
	}
`;
const desktopStyles = (0, styled_components_1.css) `
	&.score-container {
		&.empty {
			padding: 24px 0px;
		}
	}

	.class-container {
		padding: 12px 0;
	}
`;
// 평가 항목을 선택한 경우의 컴포넌트
exports.ScoreContainer = react_1.default.memo(({ isDefault, subject, initEvalData, evalData, setEvalData, isModify = false, isPopup = false, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isTablet, isMobile, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    const [totalScore, setTotalScore] = react_1.default.useState([]);
    const handlerUpdateScore = (data) => {
        setTotalScore(prevTotalScore => {
            const prevIndex = prevTotalScore.findIndex(i => i.id === data.id);
            if (prevIndex !== -1) {
                const updatedScores = [...prevTotalScore];
                updatedScores[prevIndex] = data;
                return updatedScores;
            }
            else {
                return [...prevTotalScore, data];
            }
        });
    };
    const [saveIsDefault, setSaveIsDefault] = react_1.default.useState(isDefault);
    (0, react_1.useEffect)(() => {
        if (isDefault !== saveIsDefault) {
            setEvalData([]);
        }
        setSaveIsDefault(isDefault);
    }, [isModify, isDefault]);
    if (!evalData || (evalData && evalData.length === 0)) {
        return isMobile ? (react_1.default.createElement(ScoreStyled, { "$isTablet": isTablet, "$isMobile": isMobile, className: "score-container empty", style: { color: Colors_1.Colors.light_grey } }, t('assignment.selectEvalItem'))) : (isPopup ? (react_1.default.createElement(react_1.default.Fragment, null)) : (react_1.default.createElement("div", { className: "test-item-notice" },
            react_1.default.createElement(common_1.Icon, { icon: "arrow_in_circle_left", size: "42" }),
            react_1.default.createElement("p", null, "\uAC01 \uD56D\uBAA9\uBCC4\uB85C \uD544\uC694\uD55C \uC815\uBCF4\uB97C \uC791\uC131\uD574\uC8FC\uC138\uC694"))));
    }
    const renderTableTitle = (item, score) => {
        return (react_1.default.createElement("div", { className: "task-label", style: { width: isMobile && '100%' } },
            react_1.default.createElement("p", { className: "overText" }, `${subject === 'assignment.select' || !isDefault
                ? `${item.key}`
                : subject === 'assignment.history' ||
                    subject === 'assignment.character'
                    ? `${t(`${subject}`)}`
                    : `${t(`${subject}`)} (${item.key})`}`),
            react_1.default.createElement("p", null, `- ${score}점`)));
    };
    return (react_1.default.createElement(ScoreStyled, { "$isTablet": isTablet, "$isMobile": isMobile, className: "score-container" }, evalData.length > 0 &&
        evalData.map((item, index) => {
            const initData = initEvalData.find(i => i.key === item.key);
            const score = totalScore.find(i => i.id === item.key)?.total_score || 0;
            const cloneData = lodash_1.default.cloneDeep(item, initData?.data);
            return (react_1.default.createElement("div", { className: "field-global-001 class-container", key: index, style: { flexDirection: 'column', alignItems: 'flex-start' } },
                isDesktop ? (renderTableTitle(item, score)) : (react_1.default.createElement("div", { className: "table-title-wrap" },
                    renderTableTitle(item, score),
                    react_1.default.createElement("p", { className: "notice-txt" }, t('assignment.noticeText')))),
                react_1.default.createElement("div", { className: "fext-field" },
                    react_1.default.createElement(EvaluationTable_1.EvaluationTable, { subject: subject, isDefault: isDefault, item: cloneData?.key, defaultEvalData: cloneData?.data, setEvalData: setEvalData, setTotalScore: handlerUpdateScore }))));
        })));
});
